import PropTypes from 'prop-types';
import { Icon, USER_INTERFACE_FAVORITE_STAR } from '@bwoty-web/styleguide';
import './guestReview.scss';

const MAX_RATING = 5;
const MAX_NUMBER_TEXT_CHARACTERS = 60;

const GuestReview = ({ review, labels, onClick }) => {
  if (!review) {
    return null;
  }
  const { rating, body, member, date } = review;
  const emptyAlias = '[NE__ANONYMOUS]';
  const aliasToDisplay =
    member.alias === emptyAlias || member?.alias === undefined
      ? labels.aliasPlaceholder
      : member.alias;
  const guestReviewFooterText = `${aliasToDisplay}, ${date.long}`;
  const truncateGuestReviewText =
    body?.length > MAX_NUMBER_TEXT_CHARACTERS
      ? `" ${body?.substring(0, MAX_NUMBER_TEXT_CHARACTERS)}... "`
      : `" ${body} "`;

  return (
    <button
      type="button"
      className="gw-guest-review__container"
      onClick={onClick}
    >
      <div className="gw-guest-review__header-wrap">
        <div className="gw-guest-review-rating__icon">
          <Icon
            className="gw-guest-review-star__icon"
            path={USER_INTERFACE_FAVORITE_STAR}
            size="s"
            sizeMobile="xs"
            aria-hidden="true"
          />
        </div>
        <div className="gw-guest-review-rating">
          {rating}/{MAX_RATING}
        </div>
      </div>
      <span className="gw-guest-review__body">{truncateGuestReviewText}</span>
      <span className="gw-guest-review-footer">{guestReviewFooterText}</span>
    </button>
  );
};
GuestReview.propTypes = {
  labels: PropTypes.shape({
    aliasPlaceholder: PropTypes.string,
  }).isRequired,
  review: PropTypes.shape({
    rating: PropTypes.number,
    body: PropTypes.string,
    member: PropTypes.shape({
      id: PropTypes.string,
      alias: PropTypes.string,
    }),
    date: PropTypes.shape({
      long: PropTypes.string,
      raw: PropTypes.string,
    }),
  }),
  onClick: PropTypes.func.isRequired,
};

GuestReview.defaultProps = {
  review: null,
};

export default GuestReview;
